// Keep in sync with benchling/insights/warehouse/constants.py
export const DEFAULT_SQL_QUERY = 'SELECT * FROM registry_entity ORDER BY created_at DESC LIMIT 10';
export const NO_RESULT_SQL_QUERY = 'SELECT 1 AS " " WHERE FALSE';
export const DEFAULT_QUERY_DESCRIPTION = '';

export const ROW_LIMIT = 1000;

// TODO(BNCH-102118): Fetch list of names from the backend to avoid this hardcoding.
// Keep in sync with tests/unit/warehouse/views/complex_warehouse_view_test.py
// When adding a complex view, make sure its full name is included here.
export const COMPLEX_VIEW_NAMES = new Set<string>([
  'bnch$container_validity_info',
  'bnch$procedure_run_with_procedure$beta',
  'bnch$protein_format$draft',
  'bnch$test_order_with_procedure$alpha',
  'bnch$users_with_early_names$draft',
]);

// Keep in sync with benchling/warehouse/constants.py
export const USER_DEFINED_VIEW_SCHEMA = 'custom_views';
